import { inject } from '@angular/core';
import type { ActivatedRouteSnapshot, ResolveFn } from '@angular/router';
import { ARTICLE_PAGE_MODEL } from '@banyan/commons/consts/builder-io-model.const';
import { BuilderService } from '@banyan/modules/builder-io/services/builder.service';

export const articleResolver: ResolveFn<any> = (
  route: ActivatedRouteSnapshot,
) => {
  const builderService = inject(BuilderService);
  const urlPath = '/' + route.url.map(segment => segment.path).join('/');
  return builderService.fetchContent(urlPath, ARTICLE_PAGE_MODEL);
};
